import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import CalendarWithTime from 'src/registry/components/inputs/CalendarWithTime';
import InputFormField from 'src/registry/components/forms/InputFormField';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { QUANTITY_EVENT_TYPE_MAP } from 'src/features/subscriptionItemQuantityEvents/utils/constants';
import { SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE } from 'src/features/subscriptionItemQuantityEvents/utils/types';
import { SubscriptionItemQuantityEventFormSchemaValues } from 'src/features/subscriptionItemQuantityEvents/utils/formSchema';
import { subItemQuantityEventMessages } from 'src/features/subscriptionItemQuantityEvents/utils/messages';

type SubscriptionItemQuantityEventFormProps = {
    form: UseFormReturn<SubscriptionItemQuantityEventFormSchemaValues>;
    onSubmit: (values: SubscriptionItemQuantityEventFormSchemaValues) => void;
};

function SubscriptionItemQuantityEventForm({ form, onSubmit }: SubscriptionItemQuantityEventFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <FormField
                control={form.control}
                name="recorded_at"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            {formatMessage(subItemQuantityEventMessages.recordedAt)}
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <CalendarWithTime
                                    dateISO={field.value}
                                    onChange={field.onChange}
                                    captionLayout="dropdown"
                                />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <SelectFormField<SubscriptionItemQuantityEventFormSchemaValues>
                form={form}
                name="event_type"
                required
                label={formatMessage(subItemQuantityEventMessages.eventType)}
                options={Object.values(SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE)}
                optionTranslationMap={QUANTITY_EVENT_TYPE_MAP}
            />
            <InputFormField<SubscriptionItemQuantityEventFormSchemaValues>
                form={form}
                name="quantity"
                type="number"
                label={formatMessage(subItemQuantityEventMessages.quantity)}
            />
            <p className="text-sm text-gray-500">{formatMessage(subItemQuantityEventMessages.quantityHint)}</p>
        </Form>
    );
}

export default SubscriptionItemQuantityEventForm;
